import React, { useState, useEffect } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Card, CardContent } from '../../components/ui/card';
import {
  Save,
  Loader2,
  Upload,
  Image as ImageIcon,
  Type,
  RefreshCw,
  Check,
} from 'lucide-react';
import { siteContentAPI, siteImagesAPI, mediaAPI, API_BASE } from '../../lib/api';
import { toast } from 'sonner';

const SECTIONS = [
  {
    id: 'hero',
    title: 'Hero da Homepage',
    description: 'Seção principal que aparece no topo do site',
    texts: [
      { key: 'hero-badge', label: 'Etiqueta (badge)', type: 'input' },
      { key: 'hero-title', label: 'Título principal', type: 'input' },
      { key: 'hero-subtitle', label: 'Subtítulo / Descrição', type: 'textarea' },
      { key: 'hero-credibility', label: 'Texto de credibilidade', type: 'input' },
      { key: 'hero-cta-primary', label: 'Texto do botão principal', type: 'input' },
      { key: 'hero-cta-secondary', label: 'Texto do botão secundário', type: 'input' },
    ],
    images: [
      { key: 'homepage-hero', label: 'Imagem de fundo do Hero' },
    ],
  },
  {
    id: 'stats',
    title: 'Números / Estatísticas',
    description: 'Barra de números logo abaixo do hero (100+, 5+ anos, etc.)',
    texts: [
      { key: 'stat-1-number', label: 'Número 1 (ex: 100+)', type: 'input' },
      { key: 'stat-1-label', label: 'Descrição 1 (ex: Clínicas atendidas)', type: 'input' },
      { key: 'stat-2-number', label: 'Número 2 (ex: 5+ anos)', type: 'input' },
      { key: 'stat-2-label', label: 'Descrição 2 (ex: De experiência)', type: 'input' },
      { key: 'stat-3-number', label: 'Número 3 (ex: 30%)', type: 'input' },
      { key: 'stat-3-label', label: 'Descrição 3 (ex: Economia média em impostos)', type: 'input' },
      { key: 'stat-4-number', label: 'Número 4 (ex: 98%)', type: 'input' },
      { key: 'stat-4-label', label: 'Descrição 4 (ex: Satisfação dos clientes)', type: 'input' },
    ],
    images: [],
  },
  {
    id: 'about-home',
    title: 'Seção Sobre (Homepage)',
    description: 'Seção "Sobre" que aparece na página inicial',
    texts: [
      { key: 'about-title', label: 'Título da seção', type: 'input' },
      { key: 'about-description', label: 'Descrição', type: 'textarea' },
    ],
    images: [
      { key: 'homepage-about', label: 'Imagem da seção Sobre' },
    ],
  },
  {
    id: 'cta',
    title: 'CTA (Chamada para Ação)',
    description: 'Seção de CTA que aparece em várias páginas',
    texts: [
      { key: 'cta-title', label: 'Título do CTA', type: 'input' },
      { key: 'cta-description', label: 'Descrição do CTA', type: 'textarea' },
      { key: 'cta-button', label: 'Texto do botão', type: 'input' },
    ],
    images: [],
  },
  {
    id: 'about-page',
    title: 'Página Sobre',
    description: 'Textos e imagens da página "Sobre"',
    texts: [
      { key: 'about-page-badge', label: 'Etiqueta (badge)', type: 'input' },
      { key: 'about-page-title', label: 'Título principal', type: 'input' },
      { key: 'about-page-subtitle', label: 'Subtítulo / Descrição', type: 'textarea' },
      { key: 'about-page-history-title', label: 'Título da seção "Nossa História"', type: 'input' },
      { key: 'about-page-history-p1', label: 'História - Parágrafo 1', type: 'textarea' },
      { key: 'about-page-history-p2', label: 'História - Parágrafo 2', type: 'textarea' },
      { key: 'about-page-history-p3', label: 'História - Parágrafo 3', type: 'textarea' },
      { key: 'about-page-diff-title', label: 'Título "Diferenciais"', type: 'input' },
      { key: 'about-page-diff-1-title', label: 'Diferencial 1 - Título', type: 'input' },
      { key: 'about-page-diff-1-desc', label: 'Diferencial 1 - Descrição', type: 'textarea' },
      { key: 'about-page-diff-2-title', label: 'Diferencial 2 - Título', type: 'input' },
      { key: 'about-page-diff-2-desc', label: 'Diferencial 2 - Descrição', type: 'textarea' },
      { key: 'about-page-diff-3-title', label: 'Diferencial 3 - Título', type: 'input' },
      { key: 'about-page-diff-3-desc', label: 'Diferencial 3 - Descrição', type: 'textarea' },
      { key: 'about-page-diff-4-title', label: 'Diferencial 4 - Título', type: 'input' },
      { key: 'about-page-diff-4-desc', label: 'Diferencial 4 - Descrição', type: 'textarea' },
      { key: 'about-page-milestone-1-number', label: 'Milestone 1 - Número', type: 'input' },
      { key: 'about-page-milestone-1-label', label: 'Milestone 1 - Descrição', type: 'input' },
      { key: 'about-page-milestone-2-number', label: 'Milestone 2 - Número', type: 'input' },
      { key: 'about-page-milestone-2-label', label: 'Milestone 2 - Descrição', type: 'input' },
      { key: 'about-page-milestone-3-number', label: 'Milestone 3 - Número', type: 'input' },
      { key: 'about-page-milestone-3-label', label: 'Milestone 3 - Descrição', type: 'input' },
      { key: 'about-page-milestone-4-number', label: 'Milestone 4 - Número', type: 'input' },
      { key: 'about-page-milestone-4-label', label: 'Milestone 4 - Descrição', type: 'input' },
    ],
    images: [
      { key: 'about-hero', label: 'Imagem hero da página Sobre' },
      { key: 'about-team', label: 'Imagem da equipe / escritório' },
    ],
  },
  {
    id: 'pesquisa',
    title: 'Pesquisa de Plantão (/pesquisa-plantao)',
    description: 'Textos da página da pesquisa anônima de valores de plantão',
    texts: [
      { key: 'pesquisa-badge', label: 'Etiqueta (badge)', type: 'input' },
      { key: 'pesquisa-title', label: 'Título da pesquisa', type: 'input' },
      { key: 'pesquisa-subtitle', label: 'Subtítulo / Descrição', type: 'textarea' },
      { key: 'pesquisa-privacy', label: 'Aviso de privacidade (dados anônimos)', type: 'textarea' },
      { key: 'pesquisa-cta-title', label: 'CTA da calculadora - Título', type: 'input' },
      { key: 'pesquisa-cta-text', label: 'CTA da calculadora - Texto', type: 'textarea' },
    ],
    images: [],
  },
];

const AdminSiteContent = () => {
  const [content, setContent] = useState({});
  const [images, setImages] = useState({});
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);
  const [uploadingKey, setUploadingKey] = useState(null);
  const [savedKeys, setSavedKeys] = useState(new Set());
  const [pendingImages, setPendingImages] = useState({});

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    setLoading(true);
    try {
      await Promise.all([
        siteContentAPI.init().catch(() => {}),
        siteImagesAPI.init().catch(() => {}),
      ]);
      const [contentRes, imagesRes] = await Promise.all([
        siteContentAPI.getAll(),
        siteImagesAPI.getAll(),
      ]);
      setContent(contentRes.data);
      const imgMap = {};
      (imagesRes.data || []).forEach(img => {
        imgMap[img.key] = { url: img.url, position: img.position || 'center', fit_mode: img.fit_mode || 'cover' };
      });
      setImages(imgMap);
    } catch (error) {
      toast.error('Erro ao carregar conteúdo');
    } finally {
      setLoading(false);
    }
  };

  const handleTextChange = (key, value) => {
    setContent(prev => ({ ...prev, [key]: value }));
    setSavedKeys(prev => {
      const next = new Set(prev);
      next.delete(key);
      return next;
    });
  };

  const handleSaveText = async (key) => {
    setSavingKey(key);
    try {
      await siteContentAPI.update(key, content[key] || '');
      toast.success('Texto salvo com sucesso');
      setSavedKeys(prev => new Set(prev).add(key));
    } catch (error) {
      toast.error('Erro ao salvar texto');
    } finally {
      setSavingKey(null);
    }
  };

  const handleImageSelect = (e, key) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    setPendingImages(prev => ({ ...prev, [key]: { file, previewUrl } }));
    setSavedKeys(prev => {
      const next = new Set(prev);
      next.delete(`img-${key}`);
      return next;
    });
    e.target.value = '';
  };

  const handleSaveImage = async (key) => {
    const pending = pendingImages[key];
    if (!pending) return;

    setUploadingKey(key);
    try {
      const response = await mediaAPI.upload(pending.file);
      const mediaUrl = `/api/media/${response.data.id}`;
      const imgName = SECTIONS.flatMap(s => s.images).find(i => i.key === key)?.label || key;
      const current = images[key] || {};
      await siteImagesAPI.update(key, { url: mediaUrl, name: imgName, position: current.position || 'center', fit_mode: current.fit_mode || 'cover' });
      setImages(prev => ({ ...prev, [key]: { ...current, url: mediaUrl } }));
      URL.revokeObjectURL(pending.previewUrl);
      setPendingImages(prev => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
      setSavedKeys(prev => new Set(prev).add(`img-${key}`));
      toast.success('Imagem salva com sucesso');
    } catch (error) {
      toast.error('Erro ao salvar imagem');
    } finally {
      setUploadingKey(null);
    }
  };

  const handleImageSetting = async (key, field, value) => {
    setImages(prev => ({
      ...prev,
      [key]: { ...(prev[key] || {}), [field]: value },
    }));
    try {
      await siteImagesAPI.updateSettings(key, { [field]: value });
      toast.success('Configuração salva');
    } catch (error) {
      toast.error('Erro ao salvar configuração');
    }
  };

  if (loading) {
    return (
      <div data-testid="admin-site-content">
        <div className="mb-8">
          <h1 className="font-heading text-3xl font-bold text-slate-900">Conteúdo do Site</h1>
          <p className="text-slate-600">Edite textos e imagens que aparecem no site</p>
        </div>
        <div className="space-y-6">
          {[1, 2, 3].map(i => <div key={i} className="skeleton h-48 rounded-xl" />)}
        </div>
      </div>
    );
  }

  return (
    <div data-testid="admin-site-content">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-heading text-3xl font-bold text-slate-900">Conteúdo do Site</h1>
          <p className="text-slate-600">Edite textos e imagens que aparecem no site</p>
        </div>
        <Button variant="outline" onClick={loadAll} className="btn-secondary">
          <RefreshCw className="w-4 h-4 mr-2" />
          Recarregar
        </Button>
      </div>

      <div className="space-y-8">
        {SECTIONS.map((section) => (
          <Card key={section.id} data-testid={`section-${section.id}`}>
            <CardContent className="pt-6">
              <div className="mb-6">
                <h2 className="font-heading text-xl font-semibold text-slate-900">
                  {section.title}
                </h2>
                <p className="text-sm text-slate-500">{section.description}</p>
              </div>

              <div className="space-y-5">
                {/* Text Fields */}
                {section.texts.map((field) => (
                  <div key={field.key} className="flex gap-3 items-end">
                    <div className="flex-1">
                      <Label htmlFor={field.key} className="flex items-center gap-2 mb-1.5">
                        <Type className="w-3.5 h-3.5 text-slate-400" />
                        {field.label}
                      </Label>
                      {field.type === 'textarea' ? (
                        <Textarea
                          id={field.key}
                          value={content[field.key] || ''}
                          onChange={(e) => handleTextChange(field.key, e.target.value)}
                          rows={3}
                          data-testid={`content-${field.key}`}
                        />
                      ) : (
                        <Input
                          id={field.key}
                          value={content[field.key] || ''}
                          onChange={(e) => handleTextChange(field.key, e.target.value)}
                          data-testid={`content-${field.key}`}
                        />
                      )}
                    </div>
                    <Button
                      onClick={() => handleSaveText(field.key)}
                      disabled={savingKey === field.key}
                      size="sm"
                      className={savedKeys.has(field.key) ? 'bg-green-600 hover:bg-green-700' : 'btn-primary'}
                      data-testid={`save-${field.key}`}
                    >
                      {savingKey === field.key ? (
                        <Loader2 className="w-4 h-4 animate-spin" />
                      ) : savedKeys.has(field.key) ? (
                        <Check className="w-4 h-4" />
                      ) : (
                        <Save className="w-4 h-4" />
                      )}
                    </Button>
                  </div>
                ))}

                {/* Image Fields */}
                {section.images.length > 0 && section.texts.length > 0 && (
                  <div className="border-t border-slate-100 pt-4 mt-4" />
                )}
                {section.images.map((img) => {
                  const imgData = images[img.key] || {};
                  const currentUrl = imgData.url;
                  const currentPos = imgData.position || 'center';
                  const currentFit = imgData.fit_mode || 'cover';

                  return (
                  <div key={img.key} className="space-y-3">
                    <Label className="flex items-center gap-2">
                      <ImageIcon className="w-3.5 h-3.5 text-slate-400" />
                      {img.label}
                    </Label>

                    {/* Preview */}
                    <div className="w-full h-40 rounded-lg bg-slate-100 overflow-hidden border border-slate-200">
                      {pendingImages[img.key] ? (
                        <img
                          src={pendingImages[img.key].previewUrl}
                          alt={img.label}
                          className="w-full h-full"
                          style={{ objectFit: currentFit, objectPosition: currentPos }}
                        />
                      ) : currentUrl ? (
                        <img
                          src={currentUrl}
                          alt={img.label}
                          className="w-full h-full"
                          style={{ objectFit: currentFit, objectPosition: currentPos }}
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center">
                          <ImageIcon className="w-8 h-8 text-slate-300" />
                        </div>
                      )}
                    </div>

                    {/* Upload */}
                    <div className="flex gap-2 items-center">
                      <input
                        type="file"
                        id={`img-upload-${img.key}`}
                        accept="image/*"
                        onChange={(e) => handleImageSelect(e, img.key)}
                        className="hidden"
                      />
                      <label htmlFor={`img-upload-${img.key}`}>
                        <Button asChild variant="outline" size="sm" className="cursor-pointer">
                          <span>
                            <Upload className="w-4 h-4 mr-2" />
                            {pendingImages[img.key] ? 'Escolher outra' : 'Escolher imagem'}
                          </span>
                        </Button>
                      </label>
                      {pendingImages[img.key] && (
                        <Button
                          onClick={() => handleSaveImage(img.key)}
                          disabled={uploadingKey === img.key}
                          size="sm"
                          className={savedKeys.has(`img-${img.key}`) ? 'bg-green-600 hover:bg-green-700' : 'btn-primary'}
                        >
                          {uploadingKey === img.key ? (
                            <Loader2 className="w-4 h-4 animate-spin mr-1" />
                          ) : savedKeys.has(`img-${img.key}`) ? (
                            <Check className="w-4 h-4 mr-1" />
                          ) : (
                            <Save className="w-4 h-4 mr-1" />
                          )}
                          {uploadingKey === img.key ? 'Salvando...' : 'Salvar'}
                        </Button>
                      )}
                      {pendingImages[img.key] && (
                        <span className="text-xs text-amber-600 font-medium">Pendente</span>
                      )}
                    </div>

                    {/* Position Control */}
                    {currentUrl && (
                      <div className="space-y-2">
                        <div>
                          <Label className="text-xs text-slate-500 mb-1 block">Posicao da imagem</Label>
                          <div className="flex gap-1">
                            {[
                              { value: 'top', label: 'Topo' },
                              { value: 'center', label: 'Centro' },
                              { value: 'bottom', label: 'Base' },
                              { value: 'left', label: 'Esq' },
                              { value: 'right', label: 'Dir' },
                            ].map((pos) => (
                              <button
                                key={pos.value}
                                type="button"
                                onClick={() => handleImageSetting(img.key, 'position', pos.value)}
                                className={`px-2.5 py-1 text-xs rounded border transition-colors ${
                                  currentPos === pos.value
                                    ? 'bg-[#1e4e7e] text-white border-[#1e4e7e]'
                                    : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'
                                }`}
                              >
                                {pos.label}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div>
                          <Label className="text-xs text-slate-500 mb-1 block">Modo de exibicao</Label>
                          <div className="flex gap-1">
                            {[
                              { value: 'cover', label: 'Preencher (corta)' },
                              { value: 'contain', label: 'Encaixar (inteira)' },
                            ].map((mode) => (
                              <button
                                key={mode.value}
                                type="button"
                                onClick={() => handleImageSetting(img.key, 'fit_mode', mode.value)}
                                className={`px-2.5 py-1 text-xs rounded border transition-colors ${
                                  currentFit === mode.value
                                    ? 'bg-[#1e4e7e] text-white border-[#1e4e7e]'
                                    : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'
                                }`}
                              >
                                {mode.label}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminSiteContent;
